import React from "react";
import { Modal, Box, Button } from "@mui/material";
import Loading from "../Loading";

function DocumentViewer({ open, url, loading, onClose, onIframeLoad }) {
  return (
    <Modal open={open} onClose={onClose} style={{ zIndex: "99999" }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          height: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 1,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "rgba(255,255,255,0.7)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loading />
          </Box>
        )}
        <iframe
          src={url}
          width="100%"
          height="100%"
          title="PDF Viewer"
          style={{ border: "none", flexGrow: 1 }}
          onLoad={onIframeLoad}
        />
        <div style={{ display: "flex", alignSelf: "center", gap: "10px" }}>
          <Button variant="contained" color="error" onClick={onClose} sx={{ mt: 2, width: "150px" }}>
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default DocumentViewer;
